// Misc
import React from 'react';
import { Route, Switch } from 'react-router-dom';

// Pages
import Home from './Home';
import Features from './Features';
import Pricing from './Pricing';
import Terms from './Terms';
import Privacy from './Privacy';
import Onboarding from './Onboarding';
import OnboardingSuccess from './Onboarding/Success';

export default () => (
  <Switch>
    <Route path="/features" exact component={Features} />
    <Route path="/pricing" exact component={Pricing} />
    <Route path="/terms" exact component={Terms} />
    <Route path="/privacy" exact component={Privacy} />
    <Route path="/onboarding" exact component={Onboarding} />
    <Route path="/onboarding-success" exact component={OnboardingSuccess} />
    <Route component={Home} />
  </Switch>
);



// WEBPACK FOOTER //
// ./src/pages/index.js